import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const ToolCalibrationWizardRoute: RouteType = {
  name: "ToolCalibrationWizard",
  path: "/workflows/tool-calibration",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Tool & Gauge Calibration",
      component: () => import("./ToolCalibrationWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./ToolCalibrationWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const qcStore = rootStore.qcStore as ServiceStore;
      const userStore = rootStore.userStore as ServiceStore;
      const documentManagementStore = rootStore.documentManagementStore as ServiceStore;

      await Promise.all([
        qcStore?.find(),
        userStore?.find(),
        documentManagementStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for tool calibration:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).toolCalibrationWizardStore;
    store?.reset();
  },
};

export default ToolCalibrationWizardRoute;